import BatchDetails from "./DetailLinks/BatchDetails";
import ManageParticipents from "./DetailLinks/ManageParticipents";

export const formData = [{
    key: 'seller_name',
    type: 'select',
    value: '',
    valid: false,
    regex: "^\\d+$",
    elementConfig: {
        name: 'seller_name',
        label: 'Seller Name',
        options: [],
        
    },
    validation: {
        required: true,
        message: "should be choosen"
    },

},{
    key: 'organisation_name',
    type: 'text',
    value: '',
    valid: false,
    regex: ".+",
    elementConfig: {
        name: 'organisation_name',
        label: 'Name',
        placeholder: 'Organisation Name PVT LTD'
    },
    validation: {
        required: true,
        message: "is required"

    }, 
},{
    key: 'organisation_code',
    type: 'text',
    value: '',
    valid: false,
    regex: ".+",
    elementConfig: {
        name: 'organisation_code',
        label: 'Code',
        placeholder: 'ORG'
    },
    validation: {
        required: true,
        message: "is required"
    },
},{
    key: 'address',
    type: 'text',
    value: '',
    valid: false,
    regex: ".+",
    elementConfig: {
        name: 'address',
        label: 'Address',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },
}, {
    key: 'city',
    type: 'text',
    value: '',
    valid: true,
    fieldValid:true,
    // regex: ".+",
    elementConfig: {
        name: 'city',
        label: 'City',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "is required"
    },
    fieldValidation:{
        required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
        message: "is invalid"
    }
}, {
    key: 'pincode',
    type: 'text',
    value: '',
    valid: true,
    fieldValid:true,
    // regex: "^[1-9][0-9]{5}$",
    elementConfig: {
        name: 'pincode',
        label: 'Pin Code',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "is required"
    },
    fieldValidation:{
        required: "^(?:[1-9][0-9]{5})?$",
        message: "is invalid"
    }
},{
    key: 'state',
    type: 'text',
    value: '',
    valid: true,
    // regex: "^[a-zA-Z]+$",
    fieldValid:true,
    elementConfig: {
        name: 'state',
        label: 'State',
        placeholder: ''
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
        message: "is invalid"
    }
}, {
    key: 'country_name',
    type: 'select',
    value: '',
    valid: true,
    regex: "^\\d+$",
    elementConfig: {
        name: 'country_name',
        label: 'Country',
        options: [],
        
    },
    validation: {
        required: false,
        message: "",
    },
}
]

export const editOrgDetails = [
    {
        key: 'organisation_name',
        type: 'text',
        value: '',
        valid: false,
        fieldValid:true,
        // regex: ".+",
        elementConfig: {
            name: 'organisation_name',
            label: 'Name',
            placeholder: 'Enter Organisation Name'
        },
        validation: {
            required: true,
            requiredMain: true,
            message: "is required"
        },
        fieldValidation:{
            required: "^(?:[a-zA-Z0-9 ]*)?$",
            message: "is invalid"
        }
    },
    {
        key: 'address',
        type: 'text',
        value: '',
        valid: false,
        regex: ".+",
        elementConfig: {
            name: 'address',
            label: 'Address',
            placeholder: 'Enter Address'
        },
        validation: {
            required: true,
            requiredMain: true,
            message: "is required"
        },
    },
    {
        key: 'city',
        type: 'text',
        value: '',
        valid: true,
        fieldValid:true,
        // regex: "^[a-zA-Z]+$",
        elementConfig: {
            name: 'city',
            label: 'City',
            placeholder: ''
        },
        validation: {
            required: false,
            message: ""
        },
        fieldValidation:{
            required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
            message: "is invalid"
        }
        
    },
    {
        key: 'pincode',
        type: 'pincodeText',
        value: '',
        valid: true,
        fieldValid:true,
        // regex: "^[1-9][0-9]{5}$",
        elementConfig: {
            name: 'pincode',
            label: 'Pincode',
            placeholder: ''
        },
        validation: {
            required: false,
            message: "is required"
        },
        fieldValidation:{
            required:"^[1-9][0-9]{5}$",
            message: "is invalid"
        }
    },
    {
        key: 'state',
        type: 'text',
        value: '',
        valid: true,
        fieldValid:true,
        // regex: "^[a-zA-Z]+$",
        elementConfig: {
            name: 'state',
            label: 'State',
            placeholder: ''
        },
        validation: {
            required: false,
            message: ""
        },
        fieldValidation:{
            required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
            message: "is invalid"
        }
    },
    {
        key: 'country',
        type: 'select',
        value: '',
        selected: false,
        valid: true,
        regex: "^\\d+$",
        elementConfig: {
            name: 'country_name',
            label: 'Country',
            options: [],
            storeKey: ['countries', 'countries']
        },
        validation: {
            required: false,
            message: ""
        },
    }
]

export const addAdminOrg = [
    {
        key: 'full_name',
        type: 'text',
        value: '',
        valid: false,
        regex: "^[a-zA-Z]+[a-zA-Z ]+$",
        elementConfig: {
            name: 'full_name',
            label: 'Full Name',
            placeholder: 'Enter your Full Name'
        },
        validation: {
            required: true,
            message: "is required"
        }
    },
    {
        key: 'short_name',
        type: 'text',
        value: '',
        valid: false,
        regex: "^[a-zA-Z]*[a-zA-Z ]+$",
        elementConfig: {
            name: 'short_name',
            label: 'Short Name',
            placeholder: 'Enter your Short Name'
        },
        validation: {
            required: true,
            message: "is required"
        }
    },
    {
        is_email: true,
        key: 'email',
        type: 'text',
        value: '',
        valid: false,
        regex: '^[^\\s@]+@[^\\s@]+\\.([^\\s@]{2,})+$',
        elementConfig: {
            name: 'email',
            label: 'Email',
            placeholder: 'Enter your email'
        },
        validation: {
            required: true,
            message: "is required"
        }
    }
]

export const BatchPermission = [
 
    
]


export const BatchDetail = [
    {
        key: 'min_respondent',
        type: 'number',
        value: '',
        minValue: 3,
        maxValue: 50,
        valid: false,
        elementConfig: {
            name: 'min_respondent',
            label: 'Min Respondents',
            placeholder: ''
        },
        validation: {
            required: true,
            message: "Respondent number is required"
        }
    },
]

//update mandate group
export const updateMandateGroup = [
    {
        key: 'assessor_group__assessor_name',
        chooseAnOption: true,
        type: 'select',
        value: '',
        valid: false,
        elementConfig: {
            name: 'assessor_group__assessor_name',
            label: 'MANDATE GROUP',
            options: [],
            storeKey: ['addOrgMandate', 'add_org_mandate', 'data', 'organisation_assessor_group_list']
        },
        validation: {
            required: true,
            message: "is required"
        } 
    },
]

//manage Batches

//Batch list form data

export const allotBatchFormData = [
    {
        key: 'organisation_batch_list',
        type: 'select',
        value: '',
        valid: false,
        elementConfig: {
            name: 'batch_name',
            label: 'BATCH LIST',
            options: [],
            storeKey: ['managaBatchList', 'batch_list', 'data', 'organisation_batch_list']
        },
        validation: {
            required: true,
            message: "is required"
        } 
    },
]

export const addBatch = [
    {
        key: 'batch_code',
        type: 'text',
        value: '',
        valid: false,
        elementConfig: {
            name: 'batch_code',
            label: 'Batch Code',
            placeholder: 'ORG-B05'
        },
        validation: {
            required: true,
            message: "is required"
        } 
    },
    {
        key: 'batch_name',
        type: 'text',
        value: '',
        valid: false,
        elementConfig: {
            name: 'batch_name',
            label: 'Batch Name',
            placeholder: 'Full Batch Name'
        },
        validation: {
            required: true,
            message: "is required"
        } 
    },
    {
        key: 'min_respondent',
        type: 'number',
        minValue: 3,
        maxValue: 50,
        value: '',
        valid: false,
        elementConfig: {
            name: 'min_respondent',
            label: 'Min Respondents',
            placeholder: '',
        },
        validation: {
            required: true,
            message: "is required",
            onlyNumbers: true,
        } 
    },
    {
        key: 'organisation_mandate_group',
        type: 'select',
        value: '',
        valid: true,
        elementConfig: {
            name: 'assessor_group__assessor_name',
            label: 'Mandate Group',
            options: [],
            storeKey: ['addOrgMandate', 'add_org_mandate', 'data', 'organisation_assessor_group_list']
        },
        validation: {
            required: false,
            message: ""
        } 
    },
    {
        key: 'orientations', 
        type: 'multiSelect',
        value: [],
        valid: false,
        elementConfig: {
            name: 'orientations', 
            label: 'Orientations', 
            options: [
                { id: 2, value: 'Achievement' },
                { id: 5, value: 'Relationship' },
                { id: 1, value: 'Leadership' },
                { id: 3, value: 'Learning' },
                { id: 4, value: 'Nurturing' }
            ]
        },
        validation: {
            required: true,
            message: "At least one is required"
        } 
    }


]

//

//Add Participants

export const addParticipents= [
    {
        is_email: true,
        key: 'paricipants',
        // type: 'commaSeparate',
        type: 'textarea', 
        value: '',
        valid: false,
        commaSepareted: true,
        textBelowInput: '<p style="text-align: center; font-size: 12px; color: #8a5e5e;">(You can enter multiple IDs as comma-separated values.)</p>',
        elementConfig: {
            name: 'paricipants',
            label: 'Add Participants',
            placeholder: 'name@company.com'
        },
        validation: {
            required: true,
            // message: "Separate Email with a comma or press Enter"
            message: "Enter a Valid Email"
        } 
    }
]

//

//Get Report

export const reportThemeData = [
    {
        key: 'theme_list',
        type: 'select',
        value: '',
        valid: false,
        elementConfig: {
            name: 'report_theme_name',
            label: 'SET REPORT THEME',
            options: [],
            storeKey: ['getReportTheme', 'get_theme_report', 'data', 'theme_list']
        },
        validation: {
            required: true,
            message: "is required"
        } 
    },

]

export const setExpiryDate = [
    {
        key: 'expiry_list',
        type: 'date',
        value: '',
        valid: false,
        elementConfig: {
            name: 'expiry',
            label: 'SET EXPIRY DATE',
            options: []
        },
        validation: {
            required: true,
            message: "is required"
        } 
    },

]

//Set Development Plan
export const setDevPlan = [
    {
        key: 'dev_plan',
        type: 'select',
        value: '',
        valid: false,
        elementConfig: {
            name: 'dev_plan',
            label: 'Development Plan',
            options: [
                {
                    id: 0,
                    dev_plan: 'Integrated'
                },
                {
                    id: 1,
                    dev_plan: 'Stand-Alone'
                }
            ],
            storeKey: false
        },
        validation: {
            required: true,
            message: "is required"
        } 
    },

]
    
// ManageParticipents
export const allotAssessments = [
    {
        key: 'organisation_credit_list',
        type: 'select',
        value: '',
        valid: false,
        elementConfig: {
            name: 'ChangeKeyInstrument',
            label: 'INSTRUMENT',
            options: [],
            id: 'organisation_assessment_credit__instrument',
            storeKey: ['instrumentList', 'instrument_list', 'data', 'organisation_credit_list']
        },
        validation: {
            required: true,
            message: "Instrument is required"
        } 
    },
    {
        key: 'expiry_list',
        type: 'date',
        value: '',
        valid: true,
        elementConfig: {
            name: 'expiry',
            label: 'SET EXPIRY DATE',
            options: []
        },
        validation: {
            required: true,
            message: "Expiry Date is required"
        } 
    },
    {
        key: 'organisation_batch_list',
        type: 'select',
        value: '',
        valid: true,
        elementConfig: {
            name: 'batch_name',
            label: 'BATCH LIST',
            options: [],
            storeKey: ['managaBatchList', 'batch_list', 'data', 'organisation_batch_list']
        },
        validation: {
            required: false,
            message: ""
        } 
    },
]







// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/formData.js